import { useState } from "react";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { FcGoogle } from "react-icons/fc";
import { LoginForm } from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import Spinner from "../../Common/Spinner";
import { useNavigate } from "react-router-dom";
import { ImFacebook2 } from "react-icons/im";
import { useAuth } from "../../AuthContext";
import { handleApiError } from "../../Common/Helper";
const Login = () => {
  const [loginData, setLoginData] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState();
  const navigate = useNavigate();
  // const { login } = useAuth();
  const validate = () => {
    const newErrors = {};
    // Email Validation
    if (!loginData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(loginData.email)) {
      newErrors.email = "Email is invalid";
    }

    // Password Validation
    if (!loginData.password) {
      newErrors.password = "Password is required";
    } else if (loginData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    }

    return newErrors;
  };
  const handleChange = (e) => {
    // setLoginData({ ...loginData, [e.target.name]: e.target.value });
    const { name, value } = e.target;

    setLoginData((prevData) => ({ ...prevData, [name]: value }));
    // Dynamic validation
    if (name === "password") {
      if (value.length >= 8) {
        setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          password: "Password must be at least 8 characters",
        }));
      }
    } else if (name === "email") {
      if (/\S+@\S+\.\S+/.test(value)) {
        setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "Email is invalid",
        }));
      }
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(false);
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      // Submit the form

      const formData = new FormData();

      for (const key in loginData) {
        if (loginData.hasOwnProperty(key)) {
          formData.append(key, loginData[key]);
        }
      }
      setLoading(true);
      LoginForm(formData)
        .then((res) => {
          console.log(res.data.error);
          if (res.success && res.status_code === "200") {
            localStorage.setItem("willguru-token", JSON.stringify(res.data));
            setLoading(false);
            setTimeout(() => {
              navigate("/document");
            }, [2000]);
            toast.success("Login Succesfully");
          } else {
            handleApiError(res, navigate); // Use helper function
            setLoading(false);
          }
        })
        .catch((err) => {
          toast.error("Invalid Login");
          setLoading(false);
          console.log(err);
        });
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSubmit(event); // Manually trigger the submit on Enter key
    }
  };
  return (
    <>
      <Toaster />
      <div>
        <div className="container">
          <div className="grid grid-cols-2 max-md:grid-cols-1 text-black ">
            <div className="flex justify-center items-baseline h-screen">
              <div className="bg-[#fff] w-full mx-auto px-[40px] py-[20px]  h-auto rounded-lg">
                <h3 className="text-[20px] font-bold ">
                  Already have an account?
                </h3>
                <div className="my-5">
                  <FloatingLabelInput
                    label="Email Address"
                    type="email"
                    id="email"
                    name="email"
                    // onBlur={() => setErrors(validate())} // Validate on blur
                    error={errors.email}
                    value={loginData.email}
                    required
                    onChange={(e) => handleChange(e)}
                    onKeyDown={handleKeyPress}
                  />
                </div>
                <div>
                  <FloatingLabelInput
                    label="Password"
                    type="password"
                    id="password"
                    name="password"
                    // onBlur={() => setErrors(validate())} // Validate on blur
                    error={errors.password}
                    value={loginData.password}
                    required
                    onChange={(e) => handleChange(e)}
                    onKeyDown={handleKeyPress}
                  />
                </div>
                <p className="text-right py-2">
                  <a href="/account-recovery" className="underline">
                    Forgot password?
                  </a>
                </p>
                <div>
                  {loading === false || loading === undefined ? (
                    <button
                      onClick={(e) => handleSubmit(e)}
                      className="w-full py-3 mt-3 text-white font-bold bg-primary rounded  "
                    >
                      Login
                    </button>
                  ) : (
                    <button className="w-full text-center flex justify-center py-3 mt-3 text-white font-bold bg-primary rounded  ">
                      Loggin...
                    </button>
                  )}
                </div>
                <p className="text-[14px] text-center py-2">
                  Don’t have an account?{" "}
                  <a
                    href="/signup"
                    className="underline text-primary font-bold"
                  >
                    Sign up
                  </a>
                </p>
              </div>
            </div>
            <div className="max-lg:hidden">
              <div className="fixed bottom-0 2xl:w-[800px] lg:w-[500px] right-[6%] flex justify-center">
                <img
                  src="/assets/images/1.png"
                  alt="wills-guru-logo-white"
                  className="h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
